import React from 'react';
import Header from './Header';

const SocialMediaView = ({ onClose }) => {
  const socialMediaLinks = [
    {
      name: 'Facebook',
      url: 'https://www.facebook.com/OSA.Agustinos/',
      bgColor: '#4267B2',
      iconUrl: 'https://agustinos-cdn.b-cdn.net/images/iconoFacebookAppAgustinos-solo.png',
    },
    {
      name: 'Twitter/X',
      url: 'https://twitter.com/OSA_Agustinos/',
      bgColor: '#1DA1F2',
      iconUrl: 'https://agustinos-cdn.b-cdn.net/images/iconoXAppAgustinos-solo.png',
    },
    {
      name: 'Instagram',
      url: 'https://www.instagram.com/osa.agustinos/',
      bgColor: 'radial-gradient(circle at 30% 107%, #fdf497 0%, #fdf497 5%, #fd5949 45%, #d6249f 60%, #285AEB 90%)',
      iconUrl: 'https://agustinos-cdn.b-cdn.net/images/iconoInstagramAppAgustinos-solo.png',
    },
    {
      name: 'YouTube',
      url: 'https://www.youtube.com/@agustinos',
      bgColor: '#FF0000',
      iconUrl: 'https://agustinos-cdn.b-cdn.net/images/iconoYouTubeAppAgustinos-solo.png',
    },
    {
      name: 'Email',
      url: 'mailto:comunicacion@agustinos.es',
      bgColor: '#cf3c3b',
      iconUrl: 'https://agustinos-cdn.b-cdn.net/images/iconoEmailAppAgustinos-solo.png',
    },
    {
      name: 'Web',
      url: 'https://agustinos.es/',
      bgColor: '#ff2912',
      iconUrl: 'https://agustinos-cdn.b-cdn.net/images/iconoInternetAppAgustinos-solo.png',
    }
  ];

  return (
    <div className="fixed inset-0 flex flex-col z-50" style={{
      background: 'linear-gradient(to bottom right, #ece9e6, #ffffff)'
    }}>
      {/* Header con título dinámico */}
      <Header 
        title="A tu lado" 
        showBackButton={true} 
        onBack={onClose}
      />

      {/* Contenido centrado */}
      <div className="flex-1 flex items-center justify-center">
        <div className="text-center px-4 -mt-24">
          {/* Logo */}
          <div className="mb-2">
            <img 
              src="https://agustinos-cdn.b-cdn.net/images/logoAppAgusPInicioFdoBco640_vert.png" 
              alt="Logo Agustinos" 
              className="w-44 mx-auto mb-4"
              onError={(e) => {
                console.log('❌ Error cargando logo de Agustinos');
                e.target.style.display = 'none';
              }}
            />
          </div>

          {/* Título */}
          <h2 className="text-xl font-normal text-gray-800 mb-8">
            Estamos aquí para acompañarte
          </h2>

          {/* Primera fila de iconos */}
          <div className="flex justify-center items-center space-x-4 mb-5">
            {socialMediaLinks.slice(0, 3).map((social, index) => (
              <a 
                key={index}
                href={social.url}
                target="_blank"
                rel="noopener noreferrer"
                className="transform hover:scale-110 transition-transform duration-200"
              >
                <div 
                  className="w-16 h-16 rounded-full flex items-center justify-center shadow-lg hover:shadow-xl transition-shadow duration-200"
                  style={{
                    background: social.bgColor
                  }}
                >
                  <img 
                    src={social.iconUrl}
                    alt={`${social.name} icon`}
                    className="w-16 h-16"
                    onError={(e) => {
                      console.log(`❌ Error cargando icono de ${social.name}`);
                      e.target.style.display = 'none';
                    }}
                  />
                </div>
              </a>
            ))}
          </div>

          {/* Segunda fila de iconos */}
          <div className="flex justify-center items-center space-x-4">
            {socialMediaLinks.slice(3, 6).map((social, index) => (
              <a 
                key={index}
                href={social.url}
                target="_blank"
                rel="noopener noreferrer"
                className="transform hover:scale-110 transition-transform duration-200"
              >
                <div 
                  className="w-16 h-16 rounded-full flex items-center justify-center shadow-lg hover:shadow-xl transition-shadow duration-200"
                  style={{
                    background: social.bgColor
                  }}
                >
                  <img 
                    src={social.iconUrl}
                    alt={`${social.name} icon`}
                    className="w-16 h-16"
                    onError={(e) => {
                      console.log(`❌ Error cargando icono de ${social.name}`);
                      e.target.style.display = 'none';
                    }}
                  />
                </div>
              </a>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default SocialMediaView;